import React, { useEffect, useState } from "react";
import { Picker, Item, ListBox, Text, ComboBox, Grid, Flex, View } from "@adobe/react-spectrum";
import { useAsyncList } from "@react-stately/data";
import { useTranslation } from "react-i18next";
import { useDependency } from "../../../../contexts/DependencyProvider";
import { ListFPARequest2 } from "../../../../services/soap/project/requests/ListFPARequest2";
import { ChevronDown, ChevronUp } from "react-bootstrap-icons";
import { useViewInfo } from "../../../../hooks/UseViewInfo";
import styles from './FPAListDropDown.module.css';

export interface Character {
  id: string;
  folderType: string;
  folderTypeName: string;
  referenceId: string;
  name: string;
  customState: string;
  customStateName: string;
  organization: string;
  created: string;
  createdByName: string;
  modified: string;
  modifiedByName: string;
  state: string;
  contextParent: string;
  contextParentName: string;
}

interface IFPAListDropDownProps{
  selectedFolder:string;
  onChange:(data:Character)=>void;
}

const FPAListDropDown:React.FC<IFPAListDropDownProps> = ({
  selectedFolder,
  onChange
})=> {
  const { store, projectService } = useDependency();
  const [selectedKey, setSelectedKey] = useState<string | null>(null);
  const { t } = useTranslation('products');
  const _t = (key: string) => t(`product_filters.${key}`, { ns: 'products' });
  const [toggleListVisibility, setToggleListVisibility] = useState<any>({ stateList: true });
  const { isMobile } = useViewInfo();
  useEffect(()=>{
     list.reload();
  },[])

  useEffect(() => {
        if (selectedFolder) {
          setSelectedKey(selectedFolder);
          list.reload();
        } else {
          setSelectedKey(null);
        }
      }, [selectedFolder]);

  const list = useAsyncList<Character>({
    async load({ cursor,filterText }) {
      const offset = cursor ? Number(cursor) : 0;
      const limit = 50;
      try {
        // const request = new ListFPARequest2(store.Server, store.SessionId, { limit, offset,
        //   ...(filterText ? { zipName: filterText } : { zipId: selectedZip })
        // });
        // const response = await projectService.listFPA2(request);

        var response = await projectService.listFPA2(new ListFPARequest2(
            store.Server, 
            store.SessionId,
            {
                limit: limit,
                offset: offset,
                flatView: true,
                fulltext: filterText+'*',
                folderFilter: {
                    COL: [{
                        name: 'fpaTypeCategories',
                        type: 'any',
                        value: 'com.atollon.project.fpatypecategory.supplier'
                    }]
                },
                ORDER: {
                    COL:[
                    {
                        name: 'name',
                        desc: false
                    },
                    {
                        name: 'created',
                        desc: true
                    }]
                }                
            }
        ));

        const folders = response?.ITEMS
  ? response.ITEMS.map((entry: any) => entry.ITEM?.FOLDER)
  : [];

        if (!Array.isArray(folders)) {
          console.error("Invalid API response: Expected an array", response);
          return { items: [] };
        }

        return {
          items: folders,
          cursor: folders.length === limit ? String(offset + limit) : undefined,
        };
      } catch (error) {
        console.error("Error fetching cities:", error);
        return { items: [] };
      }
    },
  });

  const handleChange = (data:any)=>{
    setSelectedKey(data);
    const selectedzip = list.items.find(x=>x.id === data);
    if(selectedzip){
      onChange(selectedzip)
    }else{
      onChange({
        id: '',
        folderType: '',
        folderTypeName: '',
        referenceId: '',
        name: data,
        customState: '',
        customStateName: '',
        organization: '',
        created: '',
        createdByName: '',
        modified: '',
        modifiedByName: '',
        state: '',
        contextParent: '',
        contextParentName: ''
      } as Character);
    }
  }

  return (
    <Flex direction={'column'} minWidth={'200px'} marginTop={'10px'} alignSelf={'stretch'} alignItems={'start'} justifyContent={'start'}>
            <Flex direction={'column'} gap={'4px'} alignSelf={'stretch'} alignItems={'start'} justifyContent={'start'} UNSAFE_className={styles.product_code_container}>
              <Flex direction={'row'} height={'36px'} alignSelf={'stretch'} alignItems={'center'} justifyContent={'space-between'} UNSAFE_className={styles.product_code_heading}>
                <Flex direction={'row'} flex={1} alignItems={'center'} justifyContent={'start'}>
                  <View position={'relative'} UNSAFE_className={styles.product_code_heading_text}>
                    {_t('search_by_manufacturer')}
                  </View>
                </Flex>
    
                {toggleListVisibility.stateList ? (
                  <ChevronDown color="#B0BEC5" onClick={() => setToggleListVisibility((preValue: any) => ({ ...preValue, stateList: false }))} style={{ cursor: 'pointer' }} />
                ) : (
                  <ChevronUp color="#B0BEC5" onClick={() => setToggleListVisibility((preValue: any) => ({ ...preValue, stateList: true }))} style={{ cursor: 'pointer' }} />
                )}
              </Flex>
              <Flex
               direction={'column'} 
               width={'200px'} 
               alignItems={'start'} 
               justifyContent={'start'} 
               marginStart={'10px'} 
               UNSAFE_style={{ display: toggleListVisibility.stateList ? '' : 'none' }}>
                  <ComboBox
    aria-label={_t("zip")}
    items={list.items}
    selectedKey={selectedKey}
    onInputChange={list.setFilterText}
    loadingState={list.loadingState}
    onLoadMore={list.loadMore}
    onSelectionChange={handleChange}
    allowsCustomValue
    width={'100%'}
>
  {(item) => (
    <Item key={item.id} textValue={item.name}>
      {item.name}
    </Item>
  )}
</ComboBox>  
            </Flex>
            </Flex>
          </Flex>
  );
};

export default FPAListDropDown;
